"use client"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ toastOptions, ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      // A Radix modal (Dialog / Sheet / Drawer) sets `pointer-events: none` on
      // <body> while it is open and re-enables pointer events ONLY inside its own
      // portal. Sonner renders OUTSIDE that portal, so a toast raised while a
      // drawer is open is fully VISIBLE but completely INERT — its action button
      // ("Open PDF") and its close button silently do nothing.
      //
      // `pointer-events` is not a locked inheritance: a descendant may re-enable
      // it even when an ancestor is `none`. So opt every toast back in.
      //
      // Deliberately an INLINE STYLE, not a `pointer-events-auto` class: this
      // must not depend on Tailwind scanning packages/ui to emit the utility. A
      // silently-missing class here would re-break every toast raised over a
      // modal, and the failure mode (button looks fine, does nothing) is exactly
      // the kind that ships unnoticed.
      toastOptions={{
        ...toastOptions,
        style: {
          pointerEvents: "auto",
          ...toastOptions?.style,
        },
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
